<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData"   ref="form" label-width="130px"
        v-loading="loading">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="title" label="标题">
              {{ formData.title || '' }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="userNames" label="关联人">
              {{ formData.userNames || "" }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>

          <el-col :span="24">
            <el-form-item prop="content" label="内容">
              {{ formData.content || '' }}
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="formData.applyResult">

          <el-row :span="24">
            <el-col :span="12">
              <el-form-item prop="approvalUserName" label="审批人">
                {{ formData.approvalUserName || '' }}
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="approvalTime" label="审批时间">
                {{ formData.approvalTime || "" }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :span="12">
              <el-form-item prop="approvalContent" label="审批意见">
                {{ formData.approvalContent || '' }}
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="applyResult" label="申请结果">
                <el-tag type="success" v-if="formData.applyResult == '1'">通过</el-tag>
                <el-tag type="danger" v-if="formData.applyResult == '2'">不通过</el-tag>
                <el-tag  v-if="formData.applyResult == '3'">待审批</el-tag>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <div class="row-wrap" v-if="$attachmentFiles(formData.fileList).length > 0">
                <div class="images-wrap" v-for="(item, index) of $attachmentFiles(formData.fileList)" :key="index">
                  <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"
                    :preview-src-list="fileImgUrl" fit="cover" />
                </div>
              </div>
              <div style="color:#999" v-else>暂无</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="onApproval" v-if="formData.applyResult == '3'&&hasApproval"  >审批</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>
<TechnologicalInnovationApproval @successSave="loadData" v-if="showDlg" :showDlg.sync="showDlg" :innovationId="formData.innovationId"></TechnologicalInnovationApproval>
  </div>
</template>

<script>
import TechnologicalInnovationApproval from '@/views/technologicalInnovation/TechnologicalInnovationApproval.vue'
export default {
  name: 'TechnologicalInnovationDetail',
  components: { TechnologicalInnovationApproval },

  data () {
    return {
      formData: {

        title: '',
        content: '',
        userIds: [],
        fileList: []
      },

      loading: false,
      showDlg: false

    }
  },
  created () {
    if (this.innovationId) {
      this.loadData()
    }
  },
  computed: {
    innovationId () {
      return this.$route.query.innovationId
    },

    fileImgUrl () {
      const arr = this.$attachmentFiles(this.formData.fileList).map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    },
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasApproval() {
      return this.buttonList.includes('approval')
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.technologicalInnovation.selectPaTechInnovationByInnovationId, {
          params: { innovationId: this.innovationId }
        })
        .then(res => {
          res.userIds = res.userIds ? res.userIds : []
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    onApproval () {
      this.showDlg = true
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.add-icon {
  font-size: 18px;
  color: #3458f9;
  cursor: pointer;
  font-weight: 600;

}

.del-icon {
  font-size: 18px;
  color: #f22d2d;
  cursor: pointer;
  font-weight: 600;
  margin-right: 14px;

}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
